import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';

const deleteSpeaker = async (speakerId: number): Promise<void> => {
  await Axios.delete(DELETE_URL(String(speakerId)).deleteSpeaker);
};

export const useDeleteSpeaker = () => {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError<BaseError>, number>(deleteSpeaker, {
    onSuccess: (_data, speakerId) => {
      queryClient.invalidateQueries(['speakers']);
      queryClient.removeQueries(['speaker', speakerId]);
    },
    useErrorBoundary: false
  });
};
